import { Box, CircularProgress, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { asMillions, asUsDate } from "components/ui/formatters";
import { useGetStatsQuery } from "features/trading/accounts";

export const PlChart = () => {
  const { data, isLoading } = useGetStatsQuery();

  if (!isLoading && data && data.results?.length > 0) {
    return (
      <Box>
        <Typography variant="h5">
          P/L:{" "}
          {asMillions(
            data.results[data.results.length - 1].total_unrealized_gain_loss,
          )}
        </Typography>

        <BarChart
          dataset={data.results as any}
          series={[
            {
              dataKey: "total_unrealized_gain_loss",
              // The tooltip amount, which is otherwise the raw number.
              valueFormatter: asMillions,
            },
          ]}
          height={360}
          xAxis={[
            {
              dataKey: "as_of_date",
              scaleType: "band",
              // Drives both the tick labels and the tooltip's date header.
              valueFormatter: asUsDate,
            },
          ]}
          sx={{ width: 100, height: 100 }}
        />
      </Box>
    );
  } else {
    return <CircularProgress />;
  }
};
